import { ApiHelper, ApiHelperWithData, ApiResponseWithData, BaseRequest, splitParams } from '..';
import { PagerData } from '../model';
import {
  BenefitInfo,
  BenefitInsert_Params,
  BenefitList,
  BenefitList_Params,
  BenefitUpdate_Params,
} from '../model/Benefit';

/**
 *  복리후생 API
 */
export class BenefitApi {
  private withData: ApiHelperWithData;
  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  /**
   * 복리후생 목록 조회
   */
  list = (
    params: BenefitList_Params & BaseRequest,
  ): Promise<ApiResponseWithData<{ list: PagerData<BenefitList> }>> => {
    const url = '/apis/benefit/list';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 복리후생 상세
   */
  info = (
    params: {
      benefitId: number;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ info: BenefitInfo }>> => {
    const url = '/apis/benefit/info';
    return this.withData.post(url, ...splitParams(params));
  };

  /**
   * 복리후생 등록
   */
  insert = (
    params: BenefitInsert_Params & BaseRequest,
  ): Promise<ApiResponseWithData<{ instCnt: number }>> => {
    const url = '/apis/benefit/insert';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 복리후생 수정
   */
  update = (
    params: BenefitUpdate_Params & BaseRequest,
  ): Promise<ApiResponseWithData<{ uptCnt: number }>> => {
    const url = '/apis/benefit/update';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 복리후생 삭제
   */
  delete = (
    params: {
      benefitId: number;
    } & BaseRequest,
  ): Promise<ApiResponseWithData<{ delCnt: number }>> => {
    const url = '/apis/benefit/delete';
    return this.withData.post(url, ...splitParams(params));
  };
}
